module.exports = __webpack_public_path__ + "assets/images/widget-tutor.ff4fd5684559b828fb361c630dbe41af.svg";